import React from 'react';
import PropTypes from 'prop-types';

import UppyUploader from '@components/common/uppy/main';
import { formattedUppyAttachment } from '@helpers/uppy';

class CustomizationUppy extends React.Component {
  handleCustomizationFiles = (files) => {
    if (!files.length) { return; }

    const file = formattedUppyAttachment(files[0]);
    const $parent = $(`.j-upload-settings-well.${this.uploadType()}`);
    $parent.find('.filepicker_object').val(JSON.stringify(file));
    $parent.find('.filepicker-complete .filename').text(file.filename);
    $parent.find('.filepicker-complete .filename').attr('href', file.url);
    $parent.find('.filepicker-complete-pane').addClass('complete');
    $parent.find('.uppy-customization-container').hide();
  }

  uploadType = () => this.props.uploadType.toLowerCase();

  trigger = () => `uppy-customization-trigger-${this.uploadType()}`;

  renderArea = () => (
    <div className="uppy-customization-settings" id={this.trigger()}>
      <p>{bfTranslate("Click to upload")}</p>
    </div>
  );

  render() {
    return (
      <React.Fragment>
        {this.renderArea()}
        <UppyUploader
          {...this.props}
          button
          handleUpload={this.handleCustomizationFiles}
          restrictions={{ maxNumberOfFiles: 1, allowedFileTypes: ['image/*'], maxFileSize: 52428800 }} // 50MB = 52428800 bytes
          template={this.uploadType()}
          trigger={`#${this.trigger()}`}
          uniqIdentifier={`uppy-customization-${this.uploadType()}`}
        />
      </React.Fragment>
    );
  }
}

CustomizationUppy.propTypes = {
  uploadType: PropTypes.string.isRequired
};

export default CustomizationUppy;
